import { SelectionModel } from "@angular/cdk/collections";
import { DatePipe, Location } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  faListAlt,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { DateTime } from "luxon";
import { Observable, of, Subscription, throwError } from "rxjs";
import { catchError, map, startWith } from "rxjs/operators";
import { EletronicTransferStatus } from "../../enum/eletronic-transfer-status.enum";
import { MenuConstants } from "../../infrastructure/MenuConstants";
import { AccountManager } from "../../model/domain/AccountManager";
import {
  DialogSize,
  MarketType,
  OperationType as OperationTypeEnum,
  OperationTypeQuota,
  Ticket,
  TicketStatus,
  TicketType as TicketTypeEnum,
  WorkflowStatus,
} from "../../model/domain/Entity";
import { Margin } from "../../model/domain/Margin";
import {
  FilterDateType,
  MonitorFilter,
} from "../../model/domain/MonitorFilter";
import { NamedType } from "../../model/domain/Tipo";
import { AuthService } from "../../services/auth.service";
import { CutoffService } from "../../services/cutoff.service";
import { DialogService } from "../../services/dialog.service";
import { DomainService, TicketType } from "../../services/domain.service";
import { DownloadService } from "../../services/download.service";
import { LoaderService } from "../../services/loader.service";
import { SecurityService } from "../../services/security.service";
import { SnackbarService } from "../../services/snackbar.service";
import { TicketService } from "../../services/ticket.service";
import { ValidatorService } from "../../services/validator.service";
import { Roles } from "../auth/auth.role";
import { TicketCutoffTicketPermission } from "../cutoff/ticket-cutoff-type.model";
import { FundQuota } from "./../../model/domain/FundQuota";
import { LiabilitiesModel } from "./../../model/domain/LiabilitiesModel";
import { OrderedTicketBySettlementDate } from "./../../model/domain/OrderedTicketBySettlementDate";
import { OperationType, SettlementType } from "./../../services/domain.service";

@Component({
  selector: "app-outstanding-monitor",
  templateUrl: "./outstanding-monitor.component.html",
  styleUrls: ["./outstanding-monitor.component.scss"],
})
export class OutstandingMonitorComponent implements OnInit {
  constructor(
    private ticketService: TicketService,
    private domainService: DomainService,
    private authService: AuthService,
    private dialogService: DialogService,
    private snackBarService: SnackbarService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    public validator: ValidatorService,
    private downloadService: DownloadService,
    private loaderService: LoaderService,
    private securityService: SecurityService,
    private datePipe: DatePipe,
    private cutoffService: CutoffService
  ) {}

  @ViewChild("thisForm", { static: true }) public frm: NgForm;

  ActiveTicketId = 0;
  TicketStatus = TicketStatus;
  TicketTypeEnum = TicketTypeEnum;
  MenuConstants = MenuConstants;

  //FontAwsome
  faListAlt = faListAlt;
  faTriangleExclamation = faTriangleExclamation;

  // Filtros
  monitorFilter: MonitorFilter = new MonitorFilter();
  AccountManagerSelected: AccountManager;
  IsTicketTypeFilter: boolean;
  today: Date = new Date();
  filterDateTypes = [
    { name: "Data de Operação", value: FilterDateType.OperationDate },
    { name: "Data de Liquidação", value: FilterDateType.SettlementDate },
  ];

  // Paginação
  defaultPage = 1;
  defaultPageSize = 10;
  pageSizeSelected = this.defaultPageSize;

  // #region Variáveis de Paginação
  quotaCurrentPage: number = this.defaultPage;
  quotaPageSize: number = this.defaultPageSize;
  quotaTotalPages: number = null;
  quotaTotalItems: number = null;
  quotaListedPages: any[];
  quotaFirstItemOnPage: number;
  quotaLastItemOnPage: number;

  liabilitiesCurrentPage: number = this.defaultPage;
  liabilitiesPageSize: number = this.defaultPageSize;
  liabilitiesTotalPages: number = null;
  liabilitiesTotalItems: number = null;
  liabilitiesListedPages: any[];
  liabilitiesFirstItemOnPage: number;
  liabilitiesLastItemOnPage: number;

  // #endregion Variáveis de Paginação

  orderedTicketsQuota: OrderedTicketBySettlementDate<FundQuota> =
    new OrderedTicketBySettlementDate();
  orderedTicketsLiability: OrderedTicketBySettlementDate<LiabilitiesModel> =
    new OrderedTicketBySettlementDate();
  QuotaTables: FundQuota[] = [];
  LiabilityTables: LiabilitiesModel[] = [];

  SelectionQuotas = new SelectionModel<FundQuota>(true, []);
  SelectionLiabilities = new SelectionModel<LiabilitiesModel>(true, []);

  ListaStatus: NamedType<any>[];
  TicketTypes: TicketType[];
  AccountManagers: AccountManager[];
  filteredAccountManagers: Observable<AccountManager[]>;
  WorkflowStatus: NamedType<any>[];

  WorkflowStatusDescription: { [x: number]: string } = {};
  OperationTypesDescription: { [x: number]: string } = {};
  QuotaOperationTypesDescription: { [x: number]: string } = {};
  SettlemenTypesDescription: { [x: number]: string } = {};
  MarketTypesDescription: { [x: number]: string } = {};

  ListOperationTypes: OperationType[] = [];
  ListSettlementTypes: SettlementType[] = [];

  hasElectronicTransfer: boolean;

  electronicTransferTimeLimit: any;

  ColumnsQuota: string[] = [
    "actions",
    "id",
    "statusId",
    "statusElectronicTransferAvailable",
    "operationDate",
    "settlementDate",
    "portfolioName",
    "portfolioDocument",
    "operationTypeId",
    "settlementTypeId",
    "operationValue",
    "fundName",
    "accountManagerName",
    "accountManagerDocument",
    "isInternalFund",
    "counterpartName",
    "cetipAccount",
    "isCetipVoice",
    "cetipVoiceId",
    "mnemonicCode",
    "counterpartCetipAccount",
    "amount",
    "quotaValue",
    "fundType",
    "portfolioAccount",
    "fundBank",
    "fundBranch",
    "fundAccount",
    "isNewFund",
    "elapsedTime",
    "lastStatusDate",
  ];

  ColumnsLiabilities: string[] = [
    "actions",
    "id",
    "statusId",
    "statusElectronicTransferAvailable",
    "operationDate",
    "settlementDate",
    "portfolioName",
    "portfolioDocument",
    "operationTypeId",
    "settlementTypeId",
    "operationValue",
    "accountManagerName",
    "accountManagerDocument",
    "cetipAccount",
    "amount",
    "quotaValue",
    "portfolioAccount",
    "fundBank",
    "fundBranch",
    "fundAccount",
    "isNewFund",
    "elapsedTime",
    "lastStatusDate",
  ];

  TicketRoleMap = {
    [TicketTypeEnum.Quota]: Roles.ViewMonitorFundQuota,
    [TicketTypeEnum.Liabilities]: Roles.ViewLiabilitiesMonitor,
  };

  TicketRoleCreateMap = {
    [TicketTypeEnum.Quota]: Roles.CreateTicketFundQuota,
    [TicketTypeEnum.Liabilities]: Roles.CreateLiabilitiesTicket,
  };

  ngOnInit() {
    this.domainService.ListTicketTypes().subscribe((types) => {
      types.sort(function (a: any, b: any) {
        return a.name > b.name ? 1 : -1;
      });
      this.TicketTypes = types;
    });

    this.ticketService.getWorkflowStatus().subscribe((wfStatus) => {
      wfStatus[-1] = "Em Elaboração";
      this.WorkflowStatusDescription = wfStatus;
      const arrWfStatus = Object.keys(wfStatus).map((key) => ({
        id: +key,
        name: wfStatus[key],
      })) as any[];
      arrWfStatus.sort(function (a: any, b: any) {
        return a.name > b.name ? 1 : -1;
      });
      this.WorkflowStatus = arrWfStatus;
    });

    this.domainService.ListOperationTypes().subscribe((types) => {
      this.ListOperationTypes = types;
      const descriptions = {};
      types.forEach((t) => {
        descriptions[t.id] = t.name;
      });
      this.OperationTypesDescription = descriptions;
    });

    this.domainService.ListSettlementTypes().subscribe((types) => {
      this.ListSettlementTypes = types;
    });

    this.route.queryParams.subscribe((params) => {
      if (JSON.stringify(params) !== "{}") {
        this.fillFilter(params);
      } else {
        this.monitorFilter.dateType = FilterDateType.SettlementDate;
      }
      this.monitorFilter.isOutstanding = true;
    });

    if (this.monitorFilter.ticketType) {
      this.ActiveTicketId = this.monitorFilter.ticketType;
    }

    if (
      !this.monitorFilter.fromDate ||
      isNaN(this.monitorFilter.fromDate.getTime())
    ) {
      this.monitorFilter.fromDate = DateTime.local().toJSDate();
    }

    this.populate();

    if (this.QuotaOperationTypesDescription) {
      const descriptions = {};

      descriptions[OperationTypeQuota.Application] = "Aplicação";
      descriptions[OperationTypeQuota.Redemption] = "Resgate";
      descriptions[OperationTypeQuota.FullRedemption] = "Resgate Total";
      descriptions[OperationTypeQuota.Amortization] =
        "Recebimento de Amortização";
      descriptions[OperationTypeQuota.Deposit] = "Depósito";
      descriptions[OperationTypeQuota.Withdrawal] = "Retirada";

      this.QuotaOperationTypesDescription = descriptions;
    }

    this.domainService.ListSettlementTypes().subscribe((types) => {
      const descriptions = {};
      types.forEach((t) => {
        descriptions[t.id] = t.name;
      });
      this.SettlemenTypesDescription = descriptions;
    });

    this.domainService.ListMarketTypes().subscribe((types) => {
      const descriptions = {};
      types.forEach((t) => {
        descriptions[t.id] = t.name;
      });
      this.MarketTypesDescription = descriptions;
    });

    if (!this.isAccountManager()) {
      this.securityService.GetAccountManagers().subscribe((a) => {
        this.AccountManagers = a;
        this.filteredAccountManagers = this.frm.controls[
          "accountManager"
        ].valueChanges.pipe(
          startWith(""),
          map((value) => (typeof value === "string" ? value : value?.name)),
          map((value) => this._searchAccountManager(value))
        );
      });
    }

    if (!this.electronicTransferTimeLimit) {
      this.ticketService.getEletronicTransferTimeLimit().subscribe((res) => {
        this.electronicTransferTimeLimit = res;
      });
    }
  }

  fillFilter(params) {
    this.monitorFilter.dateType =
      params["dateType"] != null
        ? +params["dateType"]
        : FilterDateType.OperationDate;
    this.monitorFilter.fromDate = new Date(+params["fromDate"]);
    this.monitorFilter.statusId =
      params["statusId"] != null ? +params["statusId"] : null;
    this.monitorFilter.settlementTypeId =
      params["settlementTypeId"] != null ? +params["settlementTypeId"] : null;
    this.monitorFilter.operationTypeId =
      params["operationTypeId"] != null ? +params["operationTypeId"] : null;
    this.monitorFilter.ticketType =
      params["ticketType"] != null ? +params["ticketType"] : null;
    this.monitorFilter.ticketId = params["ticketId"];
    this.monitorFilter.accountManagerId = params["accountManagerId"];
    this.monitorFilter.fundCode = params["fundCode"];
    this.monitorFilter.fundName = params["fundName"];
    this.monitorFilter.fundCnpj = params["fundCnpj"];
  }

  populate() {
    if (this.periodoError()) {
      this.snackBarService.open("Período inválido");
      return;
    }

    if (this.monitorFilter.ticketType) {
      this.load(this.monitorFilter.ticketType);
    } else {
      this.loadQuotaPaged();
      this.loadLiabilitiesPaged();
      this.IsTicketTypeFilter = false;
    }
  }

  load(ticketType: TicketTypeEnum = null, ignoreViewChanges: boolean = false) {
    switch (ticketType) {
      case TicketTypeEnum.Quota:
        this.pageSizeSelected = this.quotaPageSize;
        break;

      case TicketTypeEnum.Liabilities:
        this.pageSizeSelected = this.liabilitiesPageSize;
        break;

      default:
        this.pageSizeSelected = this.defaultPage;
        break;
    }

    const params: any[] = [
      this.monitorFilter.dateType,
      this.monitorFilter.fromDate,
      this.monitorFilter.untilDate,
      this.monitorFilter.statusId,
      this.monitorFilter.operationTypeId,
      this.monitorFilter.settlementTypeId,
      this.monitorFilter.fundCode,
      this.monitorFilter.fundName,
      this.validator.sanitize(this.monitorFilter.fundCnpj || ""),
      this.monitorFilter.ticketId,
      this.monitorFilter.accountManagerId,
      this.defaultPage,
      this.pageSizeSelected,
      this.monitorFilter.isOutstanding,
    ];
    const methods: { [x: number]: () => Subscription } = {
      [TicketTypeEnum.Quota]: () =>
        this.mapTicketData(
          this.ticketService.FundQuota.listTicket<
            OrderedTicketBySettlementDate<FundQuota>
          >(...params)
        ).subscribe(
          (orderedTickets: OrderedTicketBySettlementDate<FundQuota>) => {
            this.orderedTicketsQuota = orderedTickets;
            this.renderPaginatorQuota(orderedTickets);
          }
        ),
      [TicketTypeEnum.Liabilities]: () =>
        this.mapTicketData(
          this.ticketService.Liabilities.listTicket<
            OrderedTicketBySettlementDate<LiabilitiesModel>
          >(...params)
        ).subscribe(
          (orderedTickets: OrderedTicketBySettlementDate<LiabilitiesModel>) => {
            this.orderedTicketsLiability = orderedTickets;
            this.domainService.ListTicketTypes().subscribe((types) => {
              types.sort(function (a: any, b: any) {
                return a.name > b.name ? 1 : -1;
              });
              this.TicketTypes = types;
            });
            this.renderPaginatorLiabilities(orderedTickets);
          }
        ),
    };

    if (ticketType) {
      methods[ticketType]();

      if (!ignoreViewChanges) {
        this.ActiveTicketId = ticketType;
        this.IsTicketTypeFilter = true;
      }

      return;
    }

    Object.keys(methods).forEach((k) => {
      if (this.authService.hasRole(this.TicketRoleMap[k])) {
        methods[k]();
      }
    });

    this.IsTicketTypeFilter = false;
  }

  getParamsFromMonitorFilter() {
    return [
      this.monitorFilter.dateType,
      this.monitorFilter.fromDate,
      this.monitorFilter.untilDate,
      this.monitorFilter.statusId,
      this.monitorFilter.operationTypeId,
      this.monitorFilter.settlementTypeId,
      this.monitorFilter.fundCode,
      this.monitorFilter.fundName,
      this.validator.sanitize(this.monitorFilter.fundCnpj || ""),
      this.monitorFilter.ticketId,
      this.monitorFilter.accountManagerId,
    ];
  }

  loadQuotaPaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.quotaCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.quotaPageSize = pageSize;
    } else if (this.quotaPageSize) {
      params.push(this.quotaPageSize);
    } else {
      params.push(this.defaultPageSize);
    }
    params.push(this.monitorFilter.isOutstanding);

    this.ticketService.FundQuota.listTicket<
      OrderedTicketBySettlementDate<FundQuota>
    >(...params).subscribe(
      (orderedTickets: OrderedTicketBySettlementDate<FundQuota>) => {
        this.orderedTicketsQuota = orderedTickets;
        this.renderPaginatorQuota(orderedTickets);
      }
    );
  }

  loadLiabilitiesPaged(page: number = null, pageSize: number = null) {
    const params: any[] = this.getParamsFromMonitorFilter();

    if (page) {
      params.push(page);
    } else {
      params.push(this.quotaCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.quotaPageSize = pageSize;
    } else if (this.quotaPageSize) {
      params.push(this.quotaPageSize);
    } else {
      params.push(this.defaultPageSize);
    }
    params.push(this.monitorFilter.isOutstanding);

    this.ticketService.Liabilities.listTicket<
      OrderedTicketBySettlementDate<LiabilitiesModel>
    >(...params).subscribe(
      (orderedTickets: OrderedTicketBySettlementDate<any>) => {
        this.orderedTicketsLiability = orderedTickets;
        this.renderPaginatorLiabilities(orderedTickets);
      }
    );
  }

  mapTicketData(source: Observable<OrderedTicketBySettlementDate<any>>) {
    this.loaderService.addLoader();

    return source
      .pipe(
        catchError((err) => {
          this.loaderService.removeLoader();

          if (err.status === 404) {
            return of([]);
          }
          return throwError(err);
        })
      )
      .pipe(
        map((s: OrderedTicketBySettlementDate<any>) => {
          s.tickets.forEach((ticket) => {
            ticket.ticketsOfTheDay.forEach((ticketOfTheDay) => {
              if (ticketOfTheDay.electronicTransfers) {
                ticketOfTheDay.statusElectronicTransferAvailable =
                  ticketOfTheDay.electronicTransfers.length > 0
                    ? ticketOfTheDay.electronicTransfers[0].statusId
                    : "";

                ticketOfTheDay.lastStatusDate =
                  ticketOfTheDay.electronicTransfers.length > 0
                    ? ticketOfTheDay.electronicTransfers[0].lastStatusDate
                    : "";
              } else {
                ticketOfTheDay.statusElectronicTransferAvailable = "";
                ticketOfTheDay.lastStatusDate = "";
              }

              if (ticketOfTheDay.workflowStartDate) {
                const startDate = DateTime.fromISO(
                  ticketOfTheDay.workflowStartDate
                );
                const endDate = DateTime.fromISO(
                  ticketOfTheDay.workflowEndDate
                );

                const timestamp = DateTime.local();

                if (
                  ticketOfTheDay.workflowStartDate &&
                  ticketOfTheDay.workflowEndDate
                ) {
                  ticketOfTheDay.elapsedTime = endDate.diff(startDate, [
                    "hours",
                    "minutes",
                  ]);
                } else {
                  ticketOfTheDay.elapsedTime = timestamp.diff(startDate, [
                    "hours",
                    "minutes",
                  ]);
                }
              } else {
                ticketOfTheDay.elapsedTime = null;
              }
              if (ticketOfTheDay.portfolioDocument != null) {
                ticketOfTheDay.portfolioDocument =
                  ticketOfTheDay.portfolioDocument.replace(
                    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
                    "$1.$2.$3/$4-$5"
                  );
              }

              if (ticketOfTheDay.counterpartDocument != null) {
                ticketOfTheDay.counterpartDocument =
                  ticketOfTheDay.counterpartDocument.replace(
                    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
                    "$1.$2.$3/$4-$5"
                  );
              }

              if (
                ticketOfTheDay.portfolio != null &&
                ticketOfTheDay.portfolio.document != null
              ) {
                ticketOfTheDay.portfolio.document =
                  ticketOfTheDay.portfolio.document.replace(
                    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
                    "$1.$2.$3/$4-$5"
                  );
              }

              if (
                ticketOfTheDay.counterpart != null &&
                ticketOfTheDay.counterpart.document != null
              ) {
                ticketOfTheDay.counterpart.document =
                  ticketOfTheDay.counterpart.document.replace(
                    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
                    "$1.$2.$3/$4-$5"
                  );
              }
            });
          });
          let hasElectronicTransferTemp = false;

          s.tickets.forEach((ticket) => {
            if (
              ticket.ticketsOfTheDay.some(
                (ticketOfTheDay) =>
                  ticketOfTheDay.statusId === 11 ||
                  ticketOfTheDay.statusId === 8
              )
            ) {
              hasElectronicTransferTemp = true;
            }
          });

          this.hasElectronicTransfer = hasElectronicTransferTemp;
          this.loaderService.removeLoader();

          return s;
        })
      );
  }

  filter() {
    this.filterToParams();
    this.populate();
  }

  filterToParams() {
    this.router.navigate(["."], {
      relativeTo: this.route,
      queryParams: {
        dateType: this.monitorFilter.dateType,
        fromDate: this.monitorFilter.fromDate.getTime(),
        statusId: this.monitorFilter.statusId,
        settlementTypeId: this.monitorFilter.settlementTypeId,
        operationTypeId: this.monitorFilter.operationTypeId,
        ticketType: this.monitorFilter.ticketType,
        ticketId: this.monitorFilter.ticketId,
        fundCode: this.monitorFilter.fundCode,
        fundName: this.monitorFilter.fundName,
        fundCnpj: this.monitorFilter.fundCnpj,
        accountManangerId: this.monitorFilter.accountManagerId,
      },
    });
  }

  hasDataOn(date: string, ticketType: number, fillTable: boolean): boolean {
    let has: boolean;

    let orderedTickets = new OrderedTicketBySettlementDate().tickets;

    if (ticketType == TicketTypeEnum.Quota) {
      orderedTickets = this.orderedTicketsQuota.tickets;
    } else if (ticketType == TicketTypeEnum.Liabilities) {
      orderedTickets = this.orderedTicketsLiability.tickets;
    }

    if (orderedTickets.length > 0) {
      const filteredTickets = orderedTickets.filter((x) =>
        x.formattedSettlementDate.includes(date)
      );
      has = filteredTickets.length > 0;

      if (fillTable && has) {
        this.fillTable(filteredTickets[0].ticketsOfTheDay, ticketType);
      }
    }

    return has;
  }

  fillTable(tickets: any, ticketType: number) {
    if (ticketType == TicketTypeEnum.Quota) {
      this.QuotaTables = tickets;
    } else if (ticketType == TicketTypeEnum.Liabilities) {
      this.LiabilityTables = tickets;
    }
  }

  monthToDate(year: number, month: number): Date {
    return new Date(`${year}-${month}-1`);
  }

  clear() {
    this.monitorFilter = new MonitorFilter();
    this.monitorFilter.dateType = FilterDateType.SettlementDate;
    this.monitorFilter.isOutstanding = true;

    this.monitorFilter.fromDate = new Date(
      this.today.getFullYear(),
      this.today.getMonth(),
      this.today.getDate()
    );

    this.filterToParams();

    this.populate();
  }

  export() {
    this.loaderService.addLoader();
    const method = this.ticketService.export(
      this.monitorFilter.ticketType,
      this.monitorFilter.fromDate,
      this.monitorFilter.untilDate,
      this.monitorFilter.statusId,
      this.monitorFilter.operationTypeId,
      this.monitorFilter.settlementTypeId,
      this.monitorFilter.fundCode,
      this.monitorFilter.fundName,
      this.monitorFilter.fundCnpj,
      this.monitorFilter.ticketId,
      this.monitorFilter.accountManagerId,
      this.monitorFilter.dateType
    );

    return method.subscribe(
      (data: Blob) => {
        const filename = `boletas_${DateTime.local().toFormat(
          "yyyyMMdd"
        )}.xlsx`;
        this.downloadService.downloadFile(data, filename);

        this.loaderService.removeLoader();
      },
      () => {
        this.loaderService.removeLoader();

        this.snackBarService.open("Não foi possível exportar o arquivo.", "OK");
      }
    );
  }

  periodoError() {
    return this.monitorFilter.fromDate == null;
  }

  dateTypeFilterChange() {
    this.monitorFilter.statusId = 0;
  }

  statusFilterDisabled() {
    return this.monitorFilter.dateType == FilterDateType.SettlementDate;
  }

  isAllSelected(ticketType: TicketTypeEnum) {
    const tickets: { [x: number]: () => any } = {
      [TicketTypeEnum.Quota]: () =>
        this.SelectionQuotas.selected.length ===
        this.orderedTicketsQuota.tickets.length,
      [TicketTypeEnum.Liabilities]: () =>
        this.SelectionLiabilities.selected.length ===
        this.orderedTicketsLiability.tickets.length,
    };

    return tickets[ticketType]();
  }

  masterClear(ticketType: TicketTypeEnum) {
    const tickets: { [x: number]: () => any } = {
      [TicketTypeEnum.Quota]: () => this.SelectionQuotas,
      [TicketTypeEnum.Liabilities]: () => this.SelectionLiabilities,
    };

    const data = tickets[ticketType]();

    (data as SelectionModel<any>).clear();
  }

  hasForwardRole(ticketType: TicketTypeEnum) {
    return this.authService.hasRole(this.TicketRoleCreateMap[ticketType]);
  }

  hasApproveRole(ticketType: TicketTypeEnum): boolean {
    const tickets: { [x: number]: () => any } = {
      [TicketTypeEnum.Quota]: () => [
        this.SelectionQuotas,
        this.orderedTicketsQuota.tickets,
      ],
      [TicketTypeEnum.Liabilities]: () => [
        this.SelectionLiabilities,
        this.orderedTicketsLiability.tickets,
      ],
    };

    const data = tickets[ticketType]();

    for (const ticketTable of data[1]) {
      for (const row of ticketTable.ticketsOfTheDay) {
        if (this.canApprove(row)) {
          return true;
        }
      }
    }

    return false;
  }

  canForward(ticketType: TicketTypeEnum, row: Ticket) {
    return (
      !row.statusId &&
      !row.statusDescription &&
      this.authService.hasRole(this.TicketRoleCreateMap[ticketType])
    );
  }

  canApprove(row: any) {
    return (
      row.statusId &&
      row.statusRequiredRoles &&
      this.authService.hasRoles(row.statusRequiredRoles) &&
      (row.statusDescription != "Pendente de Aprovação pela ADM"
        ? true
        : !row.isManualSettlementDate) &&
      row.statusDescription != "Aguardando Aprovação pela Controladoria"
    );
  }

  /**
   * @description Check if can check status of Matera Tranfer
   * @returns true if workflow status is on transfer liquidation
   */
  canCheckStatusTransfer(ticketType: TicketTypeEnum): boolean {
    if (ticketType === TicketTypeEnum.Quota) {
      return (
        this.hasElectronicTransfer &&
        this.authService.hasRole(Roles.ApproveActiveSettlementMiddle)
      );
    } else {
      return (
        this.hasElectronicTransfer &&
        this.authService.hasRole(Roles.ApproveActiveSettlement)
      );
    }
  }

  canCheck(ticketType: TicketTypeEnum, row: Ticket) {
    return this.canForward(ticketType, row) || this.canApprove(row);
  }

  forwardMany(ticketType: TicketTypeEnum) {
    const methods: { [x: number]: () => any } = {
      [TicketTypeEnum.Quota]: () => [
        this.SelectionQuotas,
        (id) => this.ticketService.FundQuota.forwardTicket(id),
      ],
      [TicketTypeEnum.Liabilities]: () => [
        this.SelectionLiabilities,
        (id) => this.ticketService.Liabilities.forwardTicket(id),
      ],
    };

    const data = methods[ticketType]();

    if (data[0].selected.length === 0) {
      return;
    }

    const selectedTickets = data[0].selected;
    const checkPermissionList: TicketCutoffTicketPermission[] = [];

    const enabledToForward = [];

    for (const item of selectedTickets) {
      const itemToCheck = new TicketCutoffTicketPermission();
      itemToCheck.ticketCutoffTypeId = item.ticketCutoffTypeId;
      itemToCheck.ticketId = item.id;
      itemToCheck.accountManagerId = item.accountManagerId;

      if (item.portfolioFundId != null) {
        itemToCheck.fundId = item.portfolioFundId;
      } else if (item.portfolio.fundId != null) {
        itemToCheck.fundId = item.portfolio.fundId;
      }

      checkPermissionList.push(itemToCheck);
    }

    this.cutoffService
      .getMultiplePermisssion(checkPermissionList)
      .subscribe((res) => {
        for (const item of res) {
          const itemToForward = selectedTickets.find(
            (x) => x.id === item.ticketId && item.isAllowed
          );

          if (itemToForward) {
            enabledToForward.push(itemToForward);
          }
        }

        if (enabledToForward.length === 0) {
          this.dialogService.inform(
            "Encaminhar boletas",
            `Não é possível encaminhar a boleta após horário limite `
          );
          return;
        }
        let mensageCutoff = `Deseja encaminhar ${selectedTickets.length} boleta(s)?`;
        if (selectedTickets.length !== enabledToForward.length) {
          mensageCutoff = `Das ${selectedTickets.length} boletas selecionadas, \
        ${
          selectedTickets.length - enabledToForward.length
        } boletas não podem ser encaminhadas \
        devido ao horário de cutoff.<br/><br/> \
        Deseja encaminhar as ${enabledToForward.length} boletas restantes?`;
        }
        this.dialogService
          .confirm(
            "Encaminhar boleta(s)",
            mensageCutoff,
            null,
            null,
            DialogSize.Medium
          )
          .subscribe((result) => {
            if (!result) {
              return;
            }
            let check = Promise.resolve(true);

            if (ticketType === TicketTypeEnum.Quota) {
              const mensagem =
                "É necessário enviar a ordem desta operação para a Contraparte (Fundo Investido), \
          com a confirmação que será convertida, para que seja processada corretamente.<br /><br />\
          O não atendimento do procedimento acima poderá acarretar em cancelamento da operação e/ou atraso na \
          divulgação da cota do Fundo.";

              check = this.dialogService
                .confirm(
                  "Alerta",
                  mensagem,
                  "OK",
                  "Cancelar",
                  DialogSize.Medium
                )
                .toPromise();
            }

            for (let i = 0; i < enabledToForward.length; i++) {
              const item = enabledToForward[i] as Ticket;

              const operationDate = DateTime.fromJSDate(
                new Date(item.operationDate.toString())
              );

              if (operationDate.day < DateTime.local().day) {
                check = this.dialogService
                  .confirm(
                    "Boleta(s) Retroativa(s)",
                    "Uma ou mais boletas selecionadas possuem data de operação retroativa e serão atualizadas para a data de hoje.",
                    "OK",
                    "Cancelar"
                  )
                  .toPromise();

                break;
              }
            }

            check.then((ok) => {
              if (!ok) {
                return;
              }

              const promises: Promise<any>[] = [];
              (enabledToForward as Ticket[]).forEach((b) => {
                promises.push((data[1](b.id) as Observable<any>).toPromise());
              });
              Promise.all(promises).then(() => {
                this.snackBarService.open("Boleta(s) encaminhada(s).", "OK", {
                  verticalPosition: "top",
                  horizontalPosition: "right",
                });
                this.load(ticketType, true);
              });
              this.masterClear(ticketType);
            });
          });
      });
  }

  approveMany(ticketType: TicketTypeEnum) {
    const methods: { [x: number]: () => any } = {
      [TicketTypeEnum.Quota]: () => [
        this.SelectionQuotas,
        (id: number) => this.ticketService.approve(id),
      ],
      [TicketTypeEnum.Liabilities]: () => [
        this.SelectionLiabilities,
        (id: number) => this.ticketService.approve(id),
      ],
    };

    const data = methods[ticketType]();

    if (data[0].selected.length === 0) {
      return;
    }

    this.dialogService
      .confirm(
        "Aprovar boleta(s)",
        `Deseja aprovar ${data[0].selected.length} boleta(s)?`
      )
      .subscribe((userWantsToApproveTicket: boolean) => {
        if (userWantsToApproveTicket) {
          const promises: Promise<any>[] = [];
          (data[0].selected as Ticket[]).forEach((ticket) => {
            promises.push((data[1](ticket.id) as Observable<any>).toPromise());
          });
          Promise.all(promises).then(() => {
            this.snackBarService.open("Boleta(s) aprovadas(s).", "OK");
            this.load(ticketType, true);
          });
          this.masterClear(ticketType);
        }
      });
  }

  revise(id, params?) {
    return of({ id, params, operation: "revise" });
  }

  getById(id) {
    return of({ id, operation: "getById" });
  }

  async approveManyLiquidation(ticketType: TicketTypeEnum) {
    const methods: { [x: number]: () => any } = {
      [TicketTypeEnum.Quota]: () => [
        this.SelectionQuotas,
        (id: number, canSendTransfer: boolean) => {
          return this.ticketService.FundQuota.approveWithEletronicTransfer(
            id,
            canSendTransfer
          );
        },
      ],
    };

    const data = methods[ticketType]();

    if (data[0].selected.length === 0) {
      return;
    }

    this.dialogService
      .confirm(
        "Aprovar boleta(s)",
        `Deseja aprovar ${data[0].selected.length} boleta(s)?`
      )
      .subscribe(async (userWantsToApproveTicket: boolean) => {
        if (userWantsToApproveTicket) {
          const approvePromises: Promise<any>[] = [];

          (data[0].selected as Ticket[]).forEach((ticket) => {
            const canSendTransferForLiquidation =
              this.canSendTransferForLiquidation(ticketType, ticket.statusId);
            approvePromises.push(
              (
                data[1](
                  ticket.id,
                  canSendTransferForLiquidation
                ) as Observable<any>
              ).toPromise()
            );
          });

          await Promise.all(approvePromises).then(() => {
            this.snackBarService.open("Boleta(s) aprovadas(s).", "OK");
            this.load(ticketType, true);
          });

          this.masterClear(ticketType);
        }
      });
  }

  canSendTransferForLiquidation(
    ticketType: TicketTypeEnum,
    statusId: number
  ): boolean {
    if (ticketType === TicketTypeEnum.Quota) {
      return this.canSendTransferForLiquidationQuota(statusId);
    }
  }

  /**
   * @description Check if can send tranfer for liquidation
   * @returns true if workflow status is awaiting Shipping / Receiving of Matera Transfer
   */
  private canSendTransferForLiquidationQuota(statusId: number): boolean {
    return (
      statusId === 10 &&
      this.authService.hasRole(Roles.ApprovePendingSettlementMiddle)
    );
  }

  checkStatusMany(ticketType: TicketTypeEnum) {
    const methods: { [x: number]: () => any } = {
      [TicketTypeEnum.Quota]: () => [
        this.SelectionQuotas,
        (id: number) =>
          this.ticketService.getEletronicTransferSituationTicket(id),
      ],
    };

    const data = methods[ticketType]();

    if (data[0].selected.length === 0) {
      return;
    }

    this.dialogService
      .confirm(
        "Consultar boleta(s)",
        `Deseja consultar status ${data[0].selected.length} boleta(s)?`
      )
      .subscribe((result) => {
        if (result) {
          const promises: Promise<any>[] = [];
          (data[0].selected as Ticket[]).forEach((b) => {
            promises.push((data[1](b.id) as Observable<any>).toPromise());
          });
          Promise.all(promises)
            .then((status) => {
              this.snackBarService.open(
                "Boleta(s) status consultado(s).",
                "OK"
              );
              this.load(ticketType, true);
            })
            .catch((exception) => {
              console.error("failed:", exception.error.message);
            });
          this.masterClear(ticketType);
        }
      });
  }

  eletronicTransferStatementDialog(ticket: FundQuota | Margin) {
    this.dialogService.eletronicTransferStatement(
      ticket.portfolioAccount,
      ticket.operationDate
    );
  }

  eletronicTransferReleasesDialog(ticket: FundQuota | Margin) {
    this.dialogService.eletronicTransferReleases(
      ticket.portfolioAccount,
      ticket.operationDate
    );
  }

  transferStatusDialog(ticket: any) {
    this.dialogService.transferStatus(ticket.id);
  }

  showEletronicStatementModal(ticket: any) {
    if (
      !this.isAccountManager() &&
      (ticket.operationTypeId === OperationTypeEnum.Application ||
        ticket.operationTypeId === OperationTypeEnum.Deposit) &&
      ticket.statusElectronicTransferAvailable === EletronicTransferStatus.SENT
    ) {
      return true;
    }
    return false;
  }

  showEletronicReleasesModal(ticket: any) {
    if (
      !this.isAccountManager() &&
      (((ticket.operationTypeId === OperationTypeQuota.Redemption ||
        ticket.operationTypeId === OperationTypeQuota.FullRedemption) &&
        ticket.statusId === WorkflowStatus.InMiddleSettlement) || // && ticket.ticketType === TicketTypeEnum.Quota
        (ticket.operationTypeId === OperationTypeEnum.Withdrawal &&
          ticket.marketTypeId === MarketType.Cash &&
          ticket.statusId === WorkflowStatus.InDetainerSettlement)) && // && ticket.ticketType === TicketTypeEnum.Margin
      (ticket.statusElectronicTransferAvailable ===
        EletronicTransferStatus.SENT ||
        ticket.electronicTransfers.length === 0)
    ) {
      return true;
    }
    return false;
  }

  possibleWithoutBalance(ticket: any) {
    if (ticket.electronicTransfers.length > 0) {
      const creationDate = DateTime.fromISO(
        ticket.electronicTransfers[0].creationDate
      );
      const utcTime = DateTime.utc();

      const materaElapsedTime = utcTime.diff(creationDate, "minutes");

      if (
        this.electronicTransferTimeLimit.electronicTransferTimeLimit <
        materaElapsedTime.minutes
      ) {
        return true;
      }
    }
    return false;
  }

  setActiveTicket(id: number) {
    const url = this.router.createUrlTree([{ ticketId: id }], {
      relativeTo: this.route,
    });
    this.location.go(url.toString());
  }

  openTicket(ticket: string, id: number) {
    this.router.navigate([ticket, id]);
  }

  canDisplay(ticketType: TicketTypeEnum) {
    return (
      this.authService.hasRole(this.TicketRoleMap[ticketType]) &&
      (!this.IsTicketTypeFilter ||
        (this.IsTicketTypeFilter && this.ActiveTicketId === ticketType))
    );
  }

  isAccountManager() {
    return this.authService.authToken.isAccountManager;
  }

  onAccManagerSelected(item: any) {
    this.monitorFilter.accountManagerId = item.id;
  }

  exibeNomeAccountManager(item?: any): string | undefined {
    return item ? item.document + " " + item.name : undefined;
  }

  private _searchAccountManager(search: string): AccountManager[] {
    const searchTerm = search?.toLowerCase();

    return this.AccountManagers.filter((filtered) =>
      filtered.name.toLowerCase().includes(searchTerm)
    );
  }

  resetPaginators() {
    const listedPagesDefault: any[] = [];
    listedPagesDefault.push(1);

    this.quotaTotalPages = this.liabilitiesTotalPages;
    1;

    this.quotaCurrentPage = this.liabilitiesCurrentPage = 1;

    // tslint:disable-next-line:max-line-length
    this.quotaFirstItemOnPage = this.liabilitiesFirstItemOnPage = 0;

    this.quotaListedPages = this.liabilitiesListedPages;
    listedPagesDefault;
  }

  // #region renderPaginatorBoleta()

  renderPaginatorQuota(result: OrderedTicketBySettlementDate<any>) {
    this.quotaTotalItems = result.rowCount;
    this.quotaTotalPages = result.pageCount;
    this.quotaFirstItemOnPage = result.firstRowOnPage;
    this.quotaLastItemOnPage = result.lastRowOnPage;
    this.quotaCurrentPage = result.currentPage;
    this.quotaListedPages = [];
    let startPage = this.quotaCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }
    let maxPage = this.quotaCurrentPage + 2;
    while (maxPage > this.quotaTotalPages) {
      maxPage--;
    }
    for (let i = startPage; i <= maxPage; i++) {
      this.quotaListedPages.push(i);
    }
    if (!result.tickets.length) {
      this.quotaTotalPages = 1;
      this.quotaCurrentPage = 1;
      this.quotaFirstItemOnPage = 0;
      this.quotaListedPages = [];
      this.quotaListedPages.push(1);
    }
  }

  renderPaginatorLiabilities(result: OrderedTicketBySettlementDate<any>) {
    this.liabilitiesTotalItems = result.rowCount;
    this.liabilitiesTotalPages = result.pageCount;
    this.liabilitiesFirstItemOnPage = result.firstRowOnPage;
    this.liabilitiesLastItemOnPage = result.lastRowOnPage;
    this.liabilitiesCurrentPage = result.currentPage;
    this.liabilitiesListedPages = [];
    let startPage = this.liabilitiesCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }
    let maxPage = this.liabilitiesCurrentPage + 2;
    while (maxPage > this.liabilitiesTotalPages) {
      maxPage--;
    }
    for (let i = startPage; i <= maxPage; i++) {
      this.liabilitiesListedPages.push(i);
    }
    if (!result.tickets.length) {
      this.liabilitiesTotalPages = 1;
      this.liabilitiesCurrentPage = 1;
      this.liabilitiesFirstItemOnPage = 0;
      this.liabilitiesListedPages = [];
      this.liabilitiesListedPages.push(1);
    }
  }
  // #region renderPaginatorBoleta()
}
